import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { ConsultaDocumentacionInmueblesModel} from './ConsultaDocumentacionInmuebles.model';
import { MchInformacionEscrituraId } from './ConsultaDocumentacionInmuebles.model';
import { OpcionModel } from '../Global/Opcion.model';
import { ConfirmarEliminacionService } from '../Dialog/ConfirmarEliminacionService';


@Component({
	selector : 'ConsultaDocumentacionInmuebles',
	templateUrl : './ConsultaDocumentacionInmuebles.component.html',
	styleUrls  : ['../../../../styles.css']
})


export class ConsultaDocumentacionInmueblesComponent {
	
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar:boolean;
	public btnEditar:boolean;
	public btnEliminar:boolean;
	public btnConsultar:boolean;
	public activarDescarga:boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public listaNegocios:Array<OpcionModel>;
	public listaPrefijos:Array<OpcionModel>;
	public listaEscrituras:Array<OpcionModel>;
	public listaEstados:Array<OpcionModel>;

	public escrituras:Array<ConsultaDocumentacionInmueblesModel>;

	public form: FormGroup;
	public formErrors: any;
	public cnumcont:OpcionModel ;
	public ciddoc:OpcionModel ;
	public vidEscritura:OpcionModel ;
	public estado:OpcionModel ;


	public displayedColumns = ['Id Escritura', 'Descripción Inmueble', 'PDF Inmueble','Archivo Costos','CheckList','Facturada','Contabilizada','Estado Docs','Nota','Editar'];
	public dataDataBase:EscriturasDatabase;
	public dataSource:ExampleDataSource;

	public permisos:any;

	public bloquear:boolean = false;

	cnumcontControl = new FormControl();
	ciddocControl = new FormControl();
	vidEscrituraControl = new FormControl();
	estadoControl = new FormControl();

	cnumcontOptions: Observable<OpcionModel[]>;
	ciddocOptions: Observable<OpcionModel[]>;
	vidEscrituraOptions: Observable<OpcionModel[]>;
	EstadoOptions: Observable<OpcionModel[]>;

	public ocultar: boolean = false;
	public mensaje: string = "";

	options = [];

	

	public contrato:string;
	public prefijo:string;
	public tipoP:string;
	private SeEliminaEscritura: number = 0;

/*	public dataDataBase:NegociosDatabase;
	public dataSource:ExampleDataSource;
	*/
	@ViewChild('filter') filter: ElementRef;



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router:Router, public dialog: MatDialog, private confirmarEliminacionService:ConfirmarEliminacionService){		

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		
		this.snackBar.dismiss();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		
		this.listaNegocios = new Array();
		this.listaPrefijos = new Array();
		//this.permisos = _serviciosGenerales.seguridad.getCrud();
		//console.log('Permisos: ', this.permisos);

		this.cnumcont = new OpcionModel("","");
		this.ciddoc = new OpcionModel("","");
		this.vidEscritura = new OpcionModel("","");
		this.estado = new OpcionModel("","");

		this.form = this.formBuilder.group({
			filtroCnumcont   : [
			{
				value   : this.cnumcont.labelOpcion,
				disabled: this.bloquear
			}],
			filtroCiddoc   : [
			{
				value   : this.ciddoc.labelOpcion,
				disabled: this.bloquear
			}],
            filtroVidEscritura   : [
                {
                    value   : this.vidEscritura.labelOpcion,
                    disabled: this.bloquear
                }],
			filtroEstado   : [
					{
						value   : this.estado.labelOpcion,
						disabled: this.bloquear
					}]	
		});
		
	}


	ngOnInit(){
		//this.cargarTabla();

		this._serviciosGenerales.get('listaNegociosInmobiliaria', {ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaNegocios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));
				

				this.cnumcontOptions = this.cnumcontControl.valueChanges
				.startWith(null)
				.map(val => val ? this.filtro(val) : this.listaNegocios.slice());

				this._route.params.subscribe(params=>{
					console.log(params);
					if( !!params["cnumcont"]){
						this.tipoP = params["edi"];
						this.contrato = params["cnumcont"];
						this.prefijo = params["cprefijo"];
						for(let x in result)
							if(result[x].cnumcont.trim() == params["cnumcont"].trim())
								this.cnumcont.labelOpcion = result[x].cnumcont.trim()+' - '+result[x].vnombrenegocio.trim();
							if(!!params["ccodcon"] )
								this.eventoConsulta(params["ccodcon"]);

							if(!!params["cprefijo"] )
								this.eventoConsulta(params["cprefijo"]);
					}

				});

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar la lista de negocios", "X");
			});

		
		this.listaPrefijos.push(new OpcionModel("", ""));

		this.ciddocOptions = this.ciddocControl.valueChanges
		.startWith(null)
		.map(val => val ? this.filtroPrefijo(val) : this.listaPrefijos.slice());


	}


	private inicializarLista(cnumcont, ccodcon){
		
		this.cnumcont.labelOpcion = cnumcont;

	}


	filtro(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.listaNegocios.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 
		return x;
	}



	filtroPrefijo(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.listaPrefijos.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 		
		return x;
	}

	eventoConsulta(opcional){
		
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
		this.listaPrefijos = new Array();
		this.activarDescarga= false;
		this.ciddoc = new OpcionModel(" ", " ");
		//this.eventoConsultaEscrituras();
		

		this._serviciosGenerales.get('listaPrefijos', {cnumcont : this.cnumcont.idOpcion, ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result)
					this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));
				
				if(this.listaPrefijos.length == 0){
					this.openSnackBarEspecial("No se encontraron prefijos para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();


				this.ciddocOptions = this.ciddocControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroPrefijo(valT) : this.listaPrefijos.slice());


				if(opcional != undefined && opcional != ''){
					this.ciddoc.idOpcion = opcional+' - '+opcional;
					//this.eventoConsultaEscrituras();
				}

				//console.log(this.ciddoc);

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}

    eventoConsultaEscrituras(opcional){
		
        this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
        var ciddocTemp = this.ciddoc.idOpcion;
        ciddocTemp = ciddocTemp.substring(0,ciddocTemp.indexOf('-')).trim()


		this.listaEscrituras = new Array();
		this.vidEscritura = new OpcionModel(" ", " ");


		this.listaEscrituras.push(new OpcionModel("TODAS","TODAS"));

		this._serviciosGenerales.get('listadoEscriturasFacturasSinFiltro', {cnumcont : this.cnumcont.idOpcion, ciddoc : ciddocTemp ,ntipoempresa : -1}).subscribe(
			
			result=>{
				for(let x in result){
                    console.log("1");
                    this.listaEscrituras.push(new OpcionModel(result[x].vidEscritura.trim(), result[x].vdescripcion.trim()));
                }
				
				if(this.listaEscrituras.length == 0){
					this.openSnackBarEspecial("No se encontraron Escrituras para el contrato : "+this.cnumcont.idOpcion, "X");
					return;
				}
				else
					this.snackBar.dismiss();

                    
				this.vidEscrituraOptions = this.vidEscrituraControl.valueChanges
				.startWith(null)
				.map(valT => valT ? this.filtroEscrituras(valT) : this.listaEscrituras.slice());
                

				if(opcional != undefined && opcional != ''){
					
					this.vidEscritura.idOpcion = opcional+' - '+opcional;
				}

				//console.log(this.ciddoc);

			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}


    eventoConsultaEstados(){
		

		this.listaEstados = new Array();
		this.estado = new OpcionModel(" ", " ");


		this.listaEstados.push(new OpcionModel("TODOS","TODOS"));
		this.listaEstados.push(new OpcionModel(0,"Pendiente"));
		this.listaEstados.push(new OpcionModel(1,"Devuelto"));
        this.listaEstados.push(new OpcionModel(2,"Aprobado"));
		this.listaEstados.push(new OpcionModel(3,"Legalizado"));
		this.snackBar.dismiss();
		

		this.EstadoOptions = this.estadoControl.valueChanges
		.startWith(null)
		.map(valT => valT ? this.filtroEscrituras(valT) : this.listaEstados.slice());
		console.log("ESTADO OPTIONS"+this.EstadoOptions );

	}



	seguimientoEstadoEscritura(escritura : ConsultaDocumentacionInmueblesModel){
		console.log(escritura.id.cnumcont.trim(), escritura.id.vidEscritura.trim(), escritura.id.cprefijo.trim())
		this._router.navigate(['/Escritura', escritura.id.cnumcont.trim(), escritura.id.vidEscritura.trim(), escritura.id.cprefijo.trim(),'2','2','2','2','3']);
	}
	

	eventoListadoEscrituras(){

		let prefijo = this.ciddoc.idOpcion.substring(0,this.ciddoc.idOpcion.indexOf('-')).trim();
        let estadoFiltro = this.estado.idOpcion.substring(0,this.estado.idOpcion.indexOf('-')).trim()
		var vidEscrituraemp = this.vidEscritura.idOpcion;
		let caracterTemp=''
		if(vidEscrituraemp.indexOf('-')==0){
			caracterTemp='-'
			vidEscrituraemp=vidEscrituraemp.slice(1)
		}
		vidEscrituraemp = vidEscrituraemp.substring(0,vidEscrituraemp.indexOf('-')).trim()
		vidEscrituraemp=caracterTemp.trim()+vidEscrituraemp

		if(vidEscrituraemp == 'TODAS' && estadoFiltro == 'TODOS'){
			this._serviciosGenerales.get('listadoEscriturasFacturasSinFiltro', { cnumcont : this.cnumcont.idOpcion.trim(), ciddoc : prefijo, ntipoempresa : -1}).subscribe(

				result=>{
					this.dataDataBase = new EscriturasDatabase();
					this.dataDataBase.clear();
					this.dataSource = new ExampleDataSource(this.dataDataBase);
					for(let x in result){
						this.dataDataBase.addEscritura(new ConsultaDocumentacionInmueblesModel( new MchInformacionEscrituraId(result[x].vidEscritura,result[x].cnumcont,result[x].cprefijo),result[x].cantidadCompradores,result[x].vdescripcion,result[x].nvalor,result[x].vobservacion,result[x].ncostos,result[x].ndocumento,result[x].ndocumentocostos,result[x].nvalida,result[x].nfacturada,result[x].ncontabilizada,result[x].nestado,result[x].nestadoNota));
					}
					this.dataSource = new ExampleDataSource(this.dataDataBase);
				},
				error=>{
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar las Escrituras", "X");
				});
			
		}
		else if(vidEscrituraemp == 'TODAS' && estadoFiltro != 'TODOS'){
			this._serviciosGenerales.get('listadoEscriturasFacturasSinFiltro2', { cnumcont : this.cnumcont.idOpcion.trim(), ciddoc : prefijo, ntipoempresa : -1, estado : estadoFiltro}).subscribe(

				result=>{
					this.dataDataBase = new EscriturasDatabase();
					this.dataDataBase.clear();
					this.dataSource = new ExampleDataSource(this.dataDataBase);
					for(let x in result){
						this.dataDataBase.addEscritura(new ConsultaDocumentacionInmueblesModel( new MchInformacionEscrituraId(result[x].vidEscritura,result[x].cnumcont,result[x].cprefijo),result[x].cantidadCompradores,result[x].vdescripcion,result[x].nvalor,result[x].vobservacion,result[x].ncostos,result[x].ndocumento,result[x].ndocumentocostos,result[x].nvalida,result[x].nfacturada,result[x].ncontabilizada,result[x].nestado,result[x].nestadoNota));
					}
					this.dataSource = new ExampleDataSource(this.dataDataBase);
				},
				error=>{
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar las Escrituras", "X");
				});
			
		}

		else if(vidEscrituraemp != 'TODAS' && estadoFiltro == 'TODOS'){
			this._serviciosGenerales.get('listadoEscriturasFacturasSinFiltro3', { cnumcont : this.cnumcont.idOpcion.trim(), ciddoc : prefijo, ntipoempresa : -1, vidEscritura:vidEscrituraemp}).subscribe(

				result=>{
					this.dataDataBase = new EscriturasDatabase();
					this.dataDataBase.clear();
					this.dataSource = new ExampleDataSource(this.dataDataBase);
					for(let x in result){
						this.dataDataBase.addEscritura(new ConsultaDocumentacionInmueblesModel( new MchInformacionEscrituraId(result[x].vidEscritura,result[x].cnumcont,result[x].cprefijo),result[x].cantidadCompradores,result[x].vdescripcion,result[x].nvalor,result[x].vobservacion,result[x].ncostos,result[x].ndocumento,result[x].ndocumentocostos,result[x].nvalida,result[x].nfacturada,result[x].ncontabilizada,result[x].nestado,result[x].nestadoNota));
					}
					this.dataSource = new ExampleDataSource(this.dataDataBase);
				},
				error=>{
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar las Escrituras", "X");
				});
			
		}

else{
		this._serviciosGenerales.get('listadoEscriturasFacturas', { cnumcont : this.cnumcont.idOpcion.trim(), ciddoc : prefijo, ntipoempresa : -1,vidEscritura:vidEscrituraemp, estado : estadoFiltro}).subscribe(            
			result=>{
				this.dataDataBase = new EscriturasDatabase();
				this.dataDataBase.clear();
				this.dataSource = new ExampleDataSource(this.dataDataBase);
				for(let x in result){
					this.dataDataBase.addEscritura(new ConsultaDocumentacionInmueblesModel( new MchInformacionEscrituraId(result[x].vidEscritura,result[x].cnumcont,result[x].cprefijo),result[x].cantidadCompradores,result[x].vdescripcion,result[x].nvalor,result[x].vobservacion,result[x].ncostos,result[x].ndocumento,result[x].ndocumentocostos,result[x].nvalida,result[x].nfacturada,result[x].ncontabilizada,result[x].nestado,result[x].nestadoNota));
				}
				
				this.dataSource = new ExampleDataSource(this.dataDataBase);
			},
			error=>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las Escrituras", "X");
			});
		}

	}




	filtroEscrituras(val: string)//: string[]
	{
		if(val == null){
			val = "";
		}
		let x = this.listaEscrituras.filter(option =>(option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1); 		
		return x;
	}


	consultarPrefijos(){
//		console.log('Entró .... ', this.cnumcont);
this._serviciosGenerales.get('listadoPrefijos', {cnumcont:this.cnumcont.idOpcion}).subscribe(


	result=>{
		this.listaPrefijos = new Array();
		for(let x in result)
			this.listaPrefijos.push(new OpcionModel(result[x].cprefijo.trim(), result[x].cprefijo.trim()));

	},
	error=>{
		var errorMensaje = <any>error;
		console.log('Error al enviar la peticion ', errorMensaje);
		this.openSnackBarEspecial("Ocurrió un error al momento de cargar el prefijo", "X");
	}
	);
}


editar(escritura : ConsultaDocumentacionInmueblesModel){
	console.log(escritura.id.cnumcont,escritura.id.vidEscritura, escritura.id.cprefijo,escritura.ndocumento,escritura.ndocumentocostos);
	var cantidad;

	this._serviciosGenerales.get('validarSiSePuedeEditar', { cnumcont: escritura.id.cnumcont,videscritura:escritura.id.vidEscritura, cprefijo:escritura.id.cprefijo }).subscribe(
		result => {
			for (let x of result) {
				cantidad = x.conteo
			}
			if(cantidad == 0){
				this._router.navigate(['/Escritura', 1, escritura.id.cnumcont.trim(), escritura.id.vidEscritura.trim(), escritura.id.cprefijo.trim()]);
			}
			else{
				this.openSnackBarEspecial("No se puede Editar la escritura ya que existen facturas con saldo mayor a cero", "X");	
			}	
		},
		error => {
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
		});
}



AsignarPDF (escritura : ConsultaDocumentacionInmueblesModel){
	console.log('Entro al metodo para AsignarPDF Escritura');
	this._router.navigate(['/Escritura', 1, escritura.id.cnumcont.trim(), escritura.id.vidEscritura.trim(), escritura.id.cprefijo.trim(),escritura.ndocumento]);
}


AsignarPDFCostos (escritura : ConsultaDocumentacionInmueblesModel){
	console.log('Entro al metodo para AsignarPDF Costos ',escritura.ndocumentocostos);
	this._router.navigate(['/Escritura', 1, escritura.id.cnumcont.trim(), escritura.id.vidEscritura.trim(), escritura.id.cprefijo.trim(),escritura.ndocumento,escritura.ndocumentocostos]);
}


DescargarPDF (escritura : ConsultaDocumentacionInmueblesModel){

	if(escritura.ndocumento != 1){
		this.openSnackBarEspecial("A la fecha no se han cargado archivos", "X");
	}
		else{

			var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 
		
			this._serviciosGenerales.post('consultarArchivoMongoEscritura/Escritura/CNUMCONT='+this.cnumcont.idOpcion+
			'&CPREFIJO='+escritura.id.cprefijo.trim()+
			'&VID_ESCRITURA='+escritura.id.vidEscritura.trim()+
			'&NTIPOEMPRESA='+ntipoempresa, {
			 }).subscribe(
				result => {
					if(result.info =='0'){
						this.openSnackBarEspecial("Error en el servicio, por favor contacte al administrador", "X");
						return ;
					}
					if(result.info !== undefined){
						
						this._serviciosGenerales.descargarArchivo('generarPdfInmobiliaria/Escritura/CNUMCONT='+this.cnumcont.idOpcion+
						'&CPREFIJO='+escritura.id.cprefijo.trim()+
						'&VID_ESCRITURA='+escritura.id.vidEscritura.trim()+
						'&NTIPOEMPRESA='+ntipoempresa
						,null);
						
					}else{
						this.openSnackBarEspecial("El archivo no se encuentra cargado, por favor subirlo nuevamente", "X");
					}
				},
				error => {
					var errorMensaje = <any>error;
					//console.log('Error al enviar la peticion ', errorMensaje);
				});	

	}
}

DescargarPDFCostos (escritura : ConsultaDocumentacionInmueblesModel){
	
	if(escritura.ndocumentocostos != 1){
		this.openSnackBarEspecial("A la fecha no se han cargado archivos de Costos", "X");
	}
	else{
		var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 
		
			this._serviciosGenerales.post('consultarArchivoMongoEscritura/Costos/CNUMCONT='+this.cnumcont.idOpcion+
			'&CPREFIJO='+escritura.id.cprefijo.trim()+
			'&VID_ESCRITURA='+escritura.id.vidEscritura.trim()+
			'&NTIPOEMPRESA='+ntipoempresa, {
			 }).subscribe(
				result => {
					if(result.info =='0'){
						this.openSnackBarEspecial("Error en el servicio, por favor contacte al administrador", "X");
						return ;
					}
					if(result.info !== undefined){
						
						this._serviciosGenerales.descargarArchivo('generarPdfInmobiliaria/Costos/CNUMCONT='+this.cnumcont.idOpcion+
						'&CPREFIJO='+escritura.id.cprefijo.trim()+
						'&VID_ESCRITURA='+escritura.id.vidEscritura.trim()+
						'&NTIPOEMPRESA='+ntipoempresa
						,null);
						
					}else{
						this.openSnackBarEspecial("El archivo no se encuentra cargado, por favor subirlo nuevamente", "X");
					}
				},
				error => {
					var errorMensaje = <any>error;
					//console.log('Error al enviar la peticion ', errorMensaje);
				});	
	}
	
}





agregar(){
	let x = this.cnumcont.idOpcion;
	if(x == undefined || x.replace("-", "").trim() == '' ){
		this.openSnackBarEspecial("Hay que seleccionar un contrato", "X");
		return;
	}

	let negocioTemp = this.cnumcont.labelOpcion.substring(0,this.cnumcont.labelOpcion.indexOf('-')).trim();
	let conteo = 0;
	for(let y in this.listaNegocios){
		if(negocioTemp == this.listaNegocios[y].idOpcion){
			conteo = conteo + 1;
		}
	}

	if(conteo == 0){
		this.openSnackBarEspecial("Hay que seleccionar un contrato válido", "X");
		return;
	}

	x = this.ciddoc.idOpcion;

	if(x == undefined || x.replace("-", "").trim() == '' ){
		this.openSnackBarEspecial("Hay que seleccionar un prefijo", "X");
		return;
	}

	let prefijo = this.ciddoc.idOpcion.substring(0,this.ciddoc.idOpcion.indexOf('-')).trim();
	for(let y in this.listaPrefijos){
		if(this.listaPrefijos[y].idOpcion.trim() == prefijo){
			this._router.navigate(['/Escritura', 0, this.cnumcont.idOpcion.trim(), prefijo]);		
			return;
		}
	}

	this.openSnackBarEspecial("Hay que seleccionar un prefijo válido", "X");

}


eliminar(escritura:ConsultaDocumentacionInmueblesModel){
	
	var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 
	var usuario = this._serviciosGenerales.seguridad.getInfoSesion().usuario;

	this._serviciosGenerales.get('validarSiEliminaEscritura', { cnumcont: escritura.id.cnumcont,prefijo: escritura.id.cprefijo,videscritura : escritura.id.vidEscritura }).subscribe(res => {
		
		this.SeEliminaEscritura = res[0].CANTIDAD;
				if(this.SeEliminaEscritura !=0){
					this.openSnackBarEspecial("Escritura con facturas generadas, no se puede eliminar", "X");
					return;
				}
				else {
					this.confirmarEliminacionService.abrirDialog({cnumcont : escritura.id.cnumcont, cprefijo : escritura.id.cprefijo, videscritura : escritura.id.vidEscritura ,ntipoempresa : -1}, 'eliminarEscritura');
									
			
					this.confirmarEliminacionService.eventoFin$.subscribe(r=>{




						console.log('sdfgsdfgsfdgsdfgsfd');

						var parametros = "{ CNUMCONT:'"+escritura.id.cnumcont+"', CPREFIJO:"+escritura.id.cprefijo+" ,VIDESCRITURA:'"+escritura.id.vidEscritura+"',NTIPOEMPRESA:'"+ntipoempresa+"',USUARIO:"+usuario+", TIPODOCUMENTO:'ESCRITURA'"+"}";
						this._serviciosGenerales.post('eliminarArchivosMongo/'+parametros, '').subscribe(
							result=>{
								
								if(result.error == true){
										console.log('Holaaaaaaaa');
								}
							},error=>{
								var errorMensaje = <any>error;
								console.log('Error al enviar la peticion ', errorMensaje);
								this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este cargue", "X");
							})

							//this.eventoConsultaEscrituras();
					})
					
					this._serviciosGenerales.delete('insertarLogEscritura', {cnumcont : escritura.id.cnumcont, cprefijo : escritura.id.cprefijo, videscritura : escritura.id.vidEscritura ,ntipoempresa : ntipoempresa,usuario: usuario}).subscribe(
						result=>{
							if(result.error == true){
								this.openSnackBar(result.mensaje, "X");
								return;
							}		
					},error=>{
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de insertar Log", "X");

					});
				}
	}, error => {
		this.openSnackBarEspecial("Ocurrió un error al momento de consultar el valor UVT","X");
		console.log(error, '');
	})	
}




openSnackBar(message: string, action: string)
{
	this.snackBar.open(message, action, {
		duration: 20000
	});
}

openSnackBarEspecial(message: string, action: string) {
	let snackBarRef =  this.snackBar.open(message, action);

	snackBarRef.onAction().subscribe(() => {

		this.ocultar = false;
		this.mensaje = "";
	});
	
	let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
	
	if (shand.length != 0) {
			for (let i=0;i<shand.length;i++){
			shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
}

}





// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class EscriturasDatabase
{
	
	dataChange: BehaviorSubject<ConsultaDocumentacionInmueblesModel[]> = new BehaviorSubject<ConsultaDocumentacionInmueblesModel[]>([]);

	get data(): ConsultaDocumentacionInmueblesModel[]
	{
		return this.dataChange.value;
	}

	addEscritura(escritura:ConsultaDocumentacionInmueblesModel)
	{
		const copiedData = this.data.slice();
		copiedData.push(escritura);
		this.dataChange.next(copiedData);
	}

	clear(){
		this.dataChange = new BehaviorSubject<ConsultaDocumentacionInmueblesModel[]>([]);
	}

}



export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string
	{
		return this._filterChange.value;
	}

	set filter(filter: string)
	{
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: EscriturasDatabase)
	{
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<ConsultaDocumentacionInmueblesModel[]>
	{
		const displayDataChanges = [
		this._exampleDatabase.dataChange,
		this._filterChange
		];
		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: ConsultaDocumentacionInmueblesModel) => {
				let searchStr = (item.id.cprefijo).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect()
	{
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ConsultaDocumentacionInmuebles/ConsultaDocumentacionInmuebles.component.ts